import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { HpRespModuleContainerOld } from '../HpRespModuleContainerOld/HpRespModuleContainerOld';
import { HpRespEditorialModuleItemOld } from './HpRespEditorialModuleItemOld';
import { trackEditorialImpressions, trackEditorialClick } from './helpers/EditorialTrackingOld';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';

const messages = defineMessages({
    introspective: {
        id: 'homepage.modules.HpRespEditorialModuleOld.introspective',
        defaultMessage: 'Introspective Magazine',
    },
    study: {
        id: 'homepage.modules.HpRespEditorialModuleOld.study',
        defaultMessage: 'The Study',
    },
});

const HpRespEditorialModuleOldComponent = props => {
    const intl = useIntl();
    const items = get(props, 'homepage.editorialModule.items');

    const handleInitialDisplay = ({ inViewport }) => {
        if (items && inViewport) {
            trackEditorialImpressions(items);
        }
    };

    if (!items) {
        return null;
    }
    return (
        <HpRespModuleContainerOld addTopGap>
            <SharedInViewport stopWhenInViewport onInViewportChange={handleInitialDisplay}>
                <div className="rowFlex" data-tn="editorial-wrapper">
                    {items.map((item, index) => (
                        <HpRespEditorialModuleItemOld
                            key={item.cmsId}
                            item={item}
                            alt={intl.formatMessage(
                                messages[index === 0 ? 'introspective' : 'study']
                            )}
                            onClick={() => trackEditorialClick(item, index)}
                        />
                    ))}
                </div>
            </SharedInViewport>
        </HpRespModuleContainerOld>
    );
};

HpRespEditorialModuleOldComponent.propTypes = {
    homepage: PropTypes.object.isRequired,
};

export const HpRespEditorialModuleOld = createFragmentContainer(HpRespEditorialModuleOldComponent, {
    homepage: graphql`
        fragment HpRespEditorialModuleOld_homepage on Homepage {
            editorialModule: module(type: "editorial") {
                ... on EditorialModule {
                    items {
                        cmsId
                        cta
                        description
                        linkData {
                            # path is used in EditorialTrackingOld.js
                            path
                            ...SeoLink_linkData
                            ...SeoButton_linkData
                        }
                        imageUrl
                    }
                }
            }
        }
    `,
});
